import React from 'react';
import styles from './Pipeline.module.scss';
import { ReactComponent as BlueExpandIcon } from 'assets/blueExpand.svg';

interface PipelineData {
  pipelineData: any;
}

const pipelineData = {
  SALES_READY: {
    accounts: 800,
  },
  PREPARE_QUALIFY: {
    accounts: 500,
  },
  PRESENT: {
    accounts: 500,
  },
  FOLLOW_UP: {
    accounts: 400,
  },   

  pipeline: 2.2,
  pipelinePercentages: {
    SALES_READY: 'XX',
    PREPARE_QUALIFY: 'XX',
    PRESENT: 'XX',
    FOLLOW_UP: 'XX',
  },


}
const Pipeline: React.FC<{pipelineData: any}> = ({}) => {
  return (
    <div className={styles.pipelineContainer}>
      <div className={`${styles.section} `}>
        <div className={styles.topText}>
          SALES READY
        </div>
        
        <div className={styles.leads}>
          <div className={styles.subSection}>

            <div className={styles.subSectionSubText}>
              10 opportunities worth
            </div>
            <div className={styles.subSectionText}>
              ${pipelineData.SALES_READY.accounts} K
            </div>

          </div>
        </div>
        <div className={styles.middlePercentage}>
          {pipelineData.pipelinePercentages.SALES_READY} %
        </div>
      </div>

      <div style={{width: `70%`}} className={`${styles.section} ${styles.prospects}`}>
        <div className={styles.topText}>
          PREPARE/QUALIFY
        </div>
        
        <div className={styles.prospects}>
          <div className={styles.subSection}>
            <div className={styles.subSectionSubText}>
              10 opportunities worth
            </div>
            <div className={styles.subSectionText}>
              ${pipelineData.PREPARE_QUALIFY.accounts} K
            </div>
          </div>

        </div>
        <div className={styles.middlePercentage}>
          {pipelineData.pipelinePercentages.PREPARE_QUALIFY} %
        </div>
      </div>


      <div style={{width: '50%'}} className={`${styles.section} ${styles.won}`}>
        <div className={styles.topText}>
          PRESENT
        </div>

        <div className={styles.prospects}>
          <div className={styles.subSection}>
            <div className={styles.subSectionSubText}>
              2 opportunities worth
            </div>
            <div className={styles.subSectionText}>
              ${pipelineData.PRESENT.accounts} K
            </div>
          </div>
        </div>
        
        <div className={styles.middlePercentage}>
          {pipelineData.pipelinePercentages.PRESENT} %
        </div>
      </div>

      <div style={{width: `40%`}} className={`${styles.section} ${styles.opportunities}`}>
        <div className={styles.topText}>
          FOLLOW-UP
        </div>
        
        <div className={styles.opportunities}>
          <div className={styles.subSection}>
            <div className={styles.subSectionSubText}>
              2 opportunities worth
            </div>
            <div className={styles.subSectionText}>
              ${pipelineData.FOLLOW_UP.accounts} K
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export { Pipeline };
export default Pipeline;
